import { Inject, Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import {tap} from 'rxjs/operators';
import { ItemIdMap } from '@emm/core/models/item-id-mapping.model';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {standardRetry} from '@emm/core/util/rx.util';

@Injectable({ providedIn: 'root' })
export class ItemIdMappingsService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) { }

    public getAllItemIdMappingsBy(criteria: ItemIdMap): Observable<ItemIdMap[]> {
        const params: HttpParams = this.buildHttpParamsFromCriteria(criteria);
        return this.http.get(`${this.apiUrl}/itemIdMaps/findByAny`, {params}).pipe(
            tap(response => console.log('serviceMethod response: ', response)),
            standardRetry()
        );
    }

    private buildHttpParamsFromCriteria(criteria: ItemIdMap): HttpParams {
        const optionalParams = {};
        if(criteria.cfaMenuId !== null){ optionalParams['cfaMenuId'] = criteria.cfaMenuId }
        if(criteria.rmi !== null){ optionalParams['rmi'] = criteria.rmi }
        if(criteria.tag !== null){ optionalParams['tag'] = criteria.tag }
        if(criteria.pin !== null){ optionalParams['pin'] = criteria.pin }
        return new HttpParams({
            fromObject: optionalParams});
    }

    public saveAllItemIdMappings(itemIdMappings: ItemIdMap[]): Observable<ItemIdMap[]> { // same method for create and update
        return this.http
            .post(`${this.apiUrl}/itemIdMaps/saveAll`, itemIdMappings)
            .pipe(standardRetry());
    }

    public deleteItemIdMapping(itemIdMappings: ItemIdMap): Observable<ItemIdMap[]> { // same method for create and update
        return this.http
            .delete(`${this.apiUrl}/itemIdMaps/`+itemIdMappings.id)
            .pipe(standardRetry());
    }
}
